import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OutboundSsoService } from '../../services/outbound-sso.service';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

export interface OutboundSsoConfirmationData {
  message: string;
  ssoType:string;
  ssoEndPoint:string;
}

@Component({
    selector: 'app-outbound-confirmation-dialog',
    template: `
    <app-dialog
      title="{{'Confirmation'| translation:translationRequest}} "
      ariaLabel="{{'New tab opened dialog'|translation:translationRequest}}"
      [width]="500"
      [showActions]="true"
      [showConfirm]="true"
      [showCancel]="false"
      [showBack]="true"
      confirmLabel="Continue"
      [showHeader]="true"
      ariaLabelMessage="{{'Close feature not available dialog'| translation:translationRequest}}"
      (confirmEvent)="onConfirm()"
      (backEvent)="cancel($event)"
    >
      <div class="tw-py-4">
        {{ data.message | translation:translationRequest}}
      </div>
    </app-dialog>
  `,
    styles: [],
    standalone: false
})
export class OutboundSsoConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<OutboundSsoConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OutboundSsoConfirmationData,
    private outboundSsoService: OutboundSsoService
  ) {}

  translationRequest = new TranslationRequest({
      language: sessionStorage.getItem('languagepreference'),
      key: null,
      contNum: 0,
      tableName: null,
      primaryKey: null,
      primaryValue: null,
      lob: null,
      group: 'Shared',
      subGroup: 'Shared',
      });
  

  onConfirm() {    
    this.outboundSsoService.openSsoUrl(
        this.data.ssoType,
        this.data.ssoEndPoint
      );
    this.dialogRef.close();
  }

  cancel(event: Event) {
    this.dialogRef.close();
  }
}
